// React import
import React from 'react';
// Styles imports
import './TokenAnalyzerMenu.css';
import '../../util.css'
// Consts imports
import {
    TOKEN_ANALYZER_STATS,
    TOKEN_ANALYZER_WALLETS,
    TOKEN_ANALYZER_AI_STATS
} from "../../consts/consts";

class TokenAnalyzerMenu extends React.Component {

    constructor(props) {
        super(props);
    }

    getLabelClass(tab, component){
        if(tab === component) {
            return "token-analyzer__select-menu__item-label-active";
        } else {
            return "token-analyzer__select-menu__item-label-no-active";
        }
    }

    render () {

        const { tab, statsClick, walletsClick, aiStatsClick } = this.props;

        return(
            <div className={"token-analyzer__select-menu noselect"}>
                <span className={this.getLabelClass(tab, TOKEN_ANALYZER_STATS)} onClick={statsClick}>Stats</span>
                <span className={this.getLabelClass(tab, TOKEN_ANALYZER_WALLETS)} onClick={walletsClick}>Wallets</span>
                <span className={this.getLabelClass(tab, TOKEN_ANALYZER_AI_STATS)} onClick={aiStatsClick}>AI stats</span>
            </div>
        );
    }

}

export default TokenAnalyzerMenu;